export const gameFeed = {
  gameFeed: "Speletjiesstroom",
  gameFeedTitle: "Speletjiesstroom",
  gameFeedLoading: "Laai speletjie...",
  gameFeedLike: "Hou van",
  gameFeedUnlike: "Hou nie meer van",
  gameFeedLikeSingular: "hou van",
  gameFeedLikePlural: "hou van",
  gameFeedComments: "Kommentaar",
  gameFeedNoComments: "Nog geen kommentaar nie. Wees die eerste!",
  gameFeedAddComment: "Voeg 'n kommentaar by...",
  gameFeedCommentModerated:
    "Jou kommentaar is nie geplaas nie omdat dit teen ons platformbeleid ingaan. Hou asseblief kommentaar respekvol.",
  gameFeedCommentSupportRedirect:
    "Vir onttrekkings- of betalingsnavrae, kontak asseblief ons ondersteuningspan. Hierdie afdeling is slegs vir speletjiekommentaar.",
  gameFeedPost: "Plaas",
  gameFeedDelete: "Verwyder",
  gameFeedLoginToComment: "Teken in om 'n kommentaar te los",
  gameFeedLoginToLike: "Teken in om van speletjies te hou",
  gameFeedReply: "Antwoord",
  gameFeedReplyPlaceholder: "Skryf 'n antwoord...",
  gameFeedViewReplies: "Bekyk antwoorde ({{count}})",
  gameFeedViewMoreReplies: "Bekyk meer antwoorde",
  gameFeedHideReplies: "Versteek antwoorde",
  gameFeedEndOfFeed: "Jy het al die speletjies gesien!",
  gameFeedCloseGame: "Sluit speletjie",
  gameFeedExpandGame: "Brei speletjie uit na volskerm",
  gameFeedDeposit: "Deponeer",
  gameFeedBadgeHot: "Warm",
  gameFeedBadgeNew: "Nuut",
  gameFeedBadgeBigWinner: "Groot wen",
  gameFeedSwipeForAnotherGame: "Vee hier vir nog 'n speletjie",
  gameFeedSwipeShort: "Vee vir meer speletjies",
  providerProfileBack: "Terug",
  providerProfileGames: "Speletjies",
  providerProfileFollowers: "Volgers",
  providerProfileFollow: "Volg",
  providerProfileFollowing: "Volg",
  providerProfileGridView: "Ruitjie-aansig",
  providerProfileListView: "Lysaansig",
  providerProfileNoGames: "Nog geen speletjies van hierdie verskaffer beskikbaar nie.",
  providerProfileClose: "Sluit",
  providerProfilePlayGame: "Speel speletjie",
  providerDescDefault: "Aanlyn casino-speletjieverskaffer.",
  providerDescPragmatic:
    "Wêreldleier in slots en lewendige speletjies. Skeppers van Gates of Olympus, Sweet Bonanza en Wolf Gold.",
  providerDescBgaming:
    "Innoverende iGaming-ateljee met bewysbaar regverdige slots, unieke meganika en lewendige ontwerp.",
  providerDescEvoplay: "Pioniers in 3D-speletjies en gamifikasie. Meeslepende ervarings met filmiese storievertelling.",
  providerDescHacksaw: "Spesialiste in digitale krapkaarte en hoë-volatiliteit-slots met uiterste uitbetalings.",
  providerDescEvolution:
    "#1 in lewendige casino. Roulette, blackjack, speletjiesprogramme en intydse interaktiewe ervarings.",
  providerDescPixmove: "Opkomende ateljee met arcade-casino-hibriedspeletjies en vaardigheidspelemeganika.",
  providerDescUpgaming: "Verskaffer van klassieke en moderne slots met progressiewe boerpotte en bonuskenmerke.",
  providerDescEndorphina: "Premium slots met kulturele temas, hoëgehalte-grafika en presiese wiskunde.",
  providerDescBetby: "Leidende sportweddenskap-platform wat 30 000+ maandelikse byeenkomste dek.",
  providerDescTada: "Asiatiese ateljee met kleurvolle slots, massiewe vermenigvuldigers en verslawende meganika.",
  providerDescGamingcorps: "Sweedse ontwikkelaar van slots en tafelspeletjies gefokus op gehalte en regverdige spel.",
  providerDescKagaming: "Asiatiese verskaffer met 'n breë katalogus van temaslots, visvang en tafelspeletjies.",
  gameFeedFilterTitle: "Filters",
  gameFeedFilterAll: "Almal",
  gameFeedFilterTopPlayed: "Top 10",
  gameFeedFilterTournament: "Toernooi",
  gameFeedFilterDrop: "Drop",
  gameFeedFilterRace: "Wedloop",
  gameFeedFilterSectionType: "Stroomtipe",
  gameFeedFilterSectionProvider: "Verskaffer",
  gameFeedFilterSectionFeatures: "Kenmerke",
  gameFeedFilterSelectProviderFirst: "Kies 'n verskaffer om kenmerke te aktiveer",
  gameFeedFilterClear: "Maak filters skoon",
  gameFeedFilterNoResults: "Geen speletjies pas by hierdie filters nie",
  gameFeedFilterShowMore: "Wys meer",
  gameFeedFilterShowLess: "Wys minder",
  gameFeedFilterNoGamesType: '{{provider}} het geen "{{type}}"-speletjies nie',
  gameFeedFilterNoFeature: "{{provider}} het geen aktiewe {{feature}} nie",
  gameFeedFilterAccept: "Pas toe",
  storyTopGamesTitle: "Top 3 mees gespeel op {{provider}}",
};
